angular.module('CarsSaraBo').config(['$routeProvider', function($routeProvider) {
  $routeProvider.when("/audit", {
    templateUrl: 'assets/audit/index.html',
    controller: 'AuditController'
  });
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/routes/audit_route.js
// module id = 808
// module chunks = 3